import gql from 'graphql-tag';

export default gql`
  mutation createPDFLibraryItem($name: String!, $file: String!, $category: PDFLibraryCategory!) {
    createPDFLibraryItem(data: { name: $name, file: $file, category: $category }) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/createPDFLibraryItem.ts